import { Children } from 'react';

const reactChildrenUnlike = (component, children) => {
  const byArray = (candidate) => !candidate || !component.includes(candidate.type);
  const bySingle = (candidate) => !candidate || candidate.type !== component;
  return Children.toArray(children).filter(Array.isArray(component) ? byArray : bySingle);
};

// noinspection JSUnusedGlobalSymbols
export default reactChildrenUnlike;
